import { render, staticRenderFns } from "./QuestionRecords.vue?vue&type=template&id=1c4a098c&scoped=true"
import script from "./QuestionRecords.vue?vue&type=script&lang=js"
export * from "./QuestionRecords.vue?vue&type=script&lang=js"
import style0 from "./QuestionRecords.vue?vue&type=style&index=0&id=1c4a098c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a098c",
  null
  
)

export default component.exports